import { render, staticRenderFns } from "./ReturnOrder.vue?vue&type=template&id=12d5aa05&scoped=true&"
import script from "./ReturnOrder.vue?vue&type=script&lang=js&"
export * from "./ReturnOrder.vue?vue&type=script&lang=js&"
import style0 from "./ReturnOrder.vue?vue&type=style&index=0&id=12d5aa05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d5aa05",
  null
  
)

export default component.exports